var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddDox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 445.84 445.84",
    xmlSpace: "preserve",
    fill: "",
    stroke: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 15.158526
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#812EFD"
    },
    points: "393.963,97.725 304.674,97.725 304.674,8.437 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#812EFD"
    },
    points: "217.594,106.258 306.882,195.546 217.594,195.546 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#812EFD"
    },
    d: "M327.253,348.018V201.513c0-0.131-0.066-0.251-0.078-0.376c-0.036-0.525-0.131-1.032-0.304-1.533 c-0.072-0.191-0.119-0.376-0.197-0.561c-0.292-0.632-0.656-1.235-1.169-1.748L215.846,87.635c-0.513-0.513-1.116-0.877-1.748-1.17 c-0.185-0.084-0.37-0.131-0.561-0.197c-0.501-0.173-1.008-0.274-1.539-0.304c-0.125-0.006-0.245-0.078-0.376-0.078h-81.102V0 h162.221v103.692c0,3.294,2.667,5.967,5.967,5.967H402.4v238.359H327.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#812EFD"
    },
    d: "M211.627,207.48c-3.294,0-5.967-2.673-5.967-5.967V97.821h-81.108H43.439v348.018h271.88v-91.854 V207.48H211.627z M227.863,277.794h-42.514v42.514h-11.934v-42.514h-42.514V265.86h42.514v-42.514h11.934v42.514h42.514V277.794z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDox);
export default __webpack_public_path__ + "static/media/AddDox.de966c7096ab72cf6bebad2091d1307a.svg";
export { ForwardRef as ReactComponent };